import React from 'react'

const Preloader = ({visible}) => (
  <div className={`preloader_wrapper ${visible ? '' : 'hidden' }`}>
    <div className="preloader">
      <hr/>
      <hr/>
      <hr/>
      <hr/>
    </div>
  </div>
);

export default Preloader
